export default "__VITE_ASSET__C_j8pjJc__";